<template>
    <div class="feedback-step question--yes-no">
        <!-- <div class="heading-third--grey ">{{ feedbackData.text }}</div> -->
        <div class="heading-third--grey ">{{ feedbackData.text }}</div>
        <QuestionError :showEmptyError="showEmptyError" />
        <div class="scale-buttons__stars">
            <span class="button-ths button-ths--link-pink" :class="[{'selected': stars === 1}]" @click="selectStars(1)">Pretty good</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': stars === 2}]" @click="selectStars(2)">Alright</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': stars === 3}]" @click="selectStars(3)">So-so</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': stars === 4}]" @click="selectStars(4)">Could be better</span>
            <span class="button-ths button-ths--link-pink" :class="[{'selected': stars === 5}]" @click="selectStars(5)">Not so great</span>
        </div>
    </div>
</template>

<script>
    import QuestionError from '@/components/QuestionError.vue'

    export default {
        name: "StepScaleStars",
        props: {
            feedbackData: {
                required: true,
                type: Object,
            },
            savedAnswer: {
                required: true,
            },
            surveyPassingId: {},
            showEmptyError: {
                type: Boolean,
                default: false
            }
        },
        components: {QuestionError},
        data() {
            return {
                stars: '',
                showFeedback: false,
            }
        },
        methods: {
            selectStars(i) {
                /* (i === this.stars) ? this.stars = '' : this.stars = i; */
                if (i === this.stars) {
                    this.stars = '';
                    this.$emit('updateProgress', false);
                }
                else { 
                    this.stars = i;
                    this.$emit('updateProgress', true)
                }
                /* this.$emit('showFeedback', this.stars) */
                this.$emit('hideError')
            }
        }, 
        mounted() {
            if (this.savedAnswer) {
                this.stars = this.savedAnswer.value;
            }
        },
        computed: {
            questionCopy() {
                return 'question.' + this.feedbackData.id
            },
            stepResult() {
                let stepResult = {
                    answer_data: JSON.stringify({value: this.stars}),
                    question_id: this.feedbackData.id,
                };
                if (this.surveyPassingId) {
                    this._lodash.assign(stepResult, {survey_passing_id: this.surveyPassingId});
                }
                return stepResult
            },
            canContinue() {
                return (this.stars === '') ? 0 : 1 ;
            },
            feedbackDataId() {
                return this.feedbackData && this.feedbackData.id;
            },
        },
        watch: {
            savedAnswer() {
                if (this.savedAnswer) {
                    this.stars = this.savedAnswer.value;
                    if (this.stars)
                        this.$emit('showFeedback', this.stars)
                }
                else {
                    this.stars = ''
                }
            },
            feedbackDataId() {
                if (!this.savedAnswer) {
                    this.stars = '';
                }
            }
        },
    }
</script>

<style scoped>

</style>
